import { Subscription } from 'rxjs/Subscription';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  type: string;

  constructor() { }

  ngOnInit() {
    this.type = 'generico';
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/loader/component/loader.component.ts